import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/media";

interface MediaCardProps {
  item: MediaItem;
  showSynopsis?: boolean;
}

export default function MediaCard({ item, showSynopsis = true }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} - 兔六影院影视资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-900/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {item.type === "movie" ? "电影" : "电视剧"}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-primary-950">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {item.title}
        </h3>
        <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="text-background-300">|</span>
          <span>{item.region}</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
        {showSynopsis && (
          <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-2">
            {item.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}